import React from "react";
import { withStyles } from "@material-ui/core/styles";
import withUser from "../HOC/HOCwithUser.jsx";
import { connect } from "react-redux";
import { compose } from "redux";
import * as actions from "../../actions";
import {
  List,
  ListItem,
  ListItemAvatar,
  Button,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  TextField,
} from "@material-ui/core";
import ProgressiveImage from "react-progressive-image";
import ContentLoader from "react-content-loader";
import { FormattedMessage, injectIntl } from "react-intl";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { NotificationManager } from "react-notifications";

const localizer = momentLocalizer(moment);

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  inline: {
    display: "inline",
  },
  margin: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    marginBottom: "10px",
  },
});
class BookingCalendarList extends React.Component {
  constructor() {
    super();
    this.state = {
      events: [],
      data: [],
      page: 1,
      redirectId: "",
      bookingRedirect: false,
    };
  }
  componentDidMount() {
    this.getData();
  }

  getData = () => {
    console.log("Inside GetDAta");
    this.props.bookingListAction({
      page: this.state.page,
      append: false,
    });
  };

  handleEventClick = (singleEvent) => {
    console.log("Event date");
    console.log(singleEvent);
    this.props.history.push({
      pathname: `/user/booking/detail/${singleEvent.id}`,
      bookingId: singleEvent.id,
    });
  };
  render() {
    let allEvents = [];

    this.props.bookingData.forEach(function(events) {
      console.log("CALENDAR EVENTSSSSS::::", events);
      if (events.services[0]) {
        allEvents.push({
          id: events.key,
          title: events.services[0].service,
          start: moment(events.datetime).toDate(),
          end: moment(events.datetime).toDate(),
        });
      }
    });
    return (
      <div style={{ width: "100%" }}>
        <Calendar
          popup
          localizer={localizer}
          events={allEvents}
          startAccessor="start"
          endAccessor="end"
          views={["month"]}
          style={{ height: 500, color: "#000000", background: "#f9f9f9" }}
          onSelectEvent={(event) => this.handleEventClick(event)}
          culture="en-GB"
          components={{
            timeSlotWrapper: ColoredDateCellWrapper,
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ bookings }) => {
  return {
    bookingData: bookings.bookingData.bookingList,
    bookingDataCopy: bookings.bookingData,
    bookingLoader: bookings.bookingLoader,
  };
};
const composedComponent = compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    actions
  )
);

const ColoredDateCellWrapper = ({ children }) =>
  React.cloneElement(React.Children.only(children), {
    style: {
      backgroundColor: "lightblue",
    },
  });

export default composedComponent(BookingCalendarList);



// WEBPACK FOOTER //
// ./src/components/Customer/BookingCalendarList.jsx